import { ReactFlowProvider, Node } from 'reactflow';
import { VShapeFlow } from './VShapeFlow';

export const VShapeFlowProvider= ({ width, height, nodes }: {
    width: number;
    height: number;
    nodes: Array<Node<Array<Node>, string | undefined>>
}) => {
    return (
        <ReactFlowProvider>
            <VShapeFlow width={width} height={height} nodes={nodes} />
        </ReactFlowProvider>
    );
};
